import { TablePagination } from '@mui/material';
interface ITablePaginationProps {
  currentPage: number;
  totalElements: number;
  totalPages: number;
  isLoading: boolean;
  onPageChange: (page: number) => void;
}

export const TablePaginationForm = ({
  currentPage,
  totalElements,
  totalPages,
  isLoading,
  onPageChange,
}: ITablePaginationProps) => {
  if (totalPages <= 1) return null;

  return (
    <TablePagination
      component="div"
      count={totalElements}
      page={currentPage}
      rowsPerPage={50}
      rowsPerPageOptions={[]}
      onPageChange={(_, newPage) => onPageChange(newPage)}
      slotProps={{
        actions: {
          previousButton: { disabled: currentPage === 0 || isLoading },
          nextButton: { disabled: currentPage >= totalPages - 1 || isLoading },
        },
      }}
    />
  );
};
